<template>
  <div class="select-inner" v-if="this.styles[this.currentStyle].length > 1"> <!-- Style 선택 -->
    <div class="select-title">
      <h6>{{$t('cite-Style')}}</h6>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <g>
          <path fill="none" d="M0 0H10V10H0z" transform="translate(-750 -400) translate(750 400)"/>
          <path fill="#2659a8" d="M5.673 4.714l-3.242 5.414a.766.766 0 0 0 .655 1.149h6.485a.766.766 0 0 0 .655-1.149L6.983 4.714a.766.766 0 0 0-1.309 0z" transform="translate(-750 -400) rotate(90 182.302 580.975)"/>
        </g>
      </svg>
    </div>

    <div class="select-list">
      <ul class="styles">
        <li class="item" v-for="val in this.styles[this.currentStyle]">
          <button class="wv-btn" type="button" v-on:click="changeStyle(val.value)" v-bind:class="{ 'active': (selectStyle === val.value) }">{{ val.text }}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectStyle",
  props: ["currentStyle", "selectStyle"],
  data: function () {
    return {
      styles: {
        "apa" : [
          {text: "APA 7th", value: "apa7"},
          {text: "APA 6th", value: "apa6"}
        ],
        "mla" : [
          {text: "MLA 8th", value: "mla8"},
          {text: "MLA 7th", value: "mla7"}
        ],
        "chicago" : [
          {text: "Chicago 17th", value: "chicago17"}
        ],
        "vancouver" : [
          {text: "Vancouver", value: "vancouver"}
        ]
      },
    }
  },
  methods: {
    changeStyle(style) {
      this.$emit("changeStyle", style)
    }
  }
}
</script>

<style scoped>
  .select-list {
    width: 100%;
  }

  .styles {
    display: flex;
    gap: 1rem;
  }

  .styles .item {
    flex: 1;
    margin: 0 !important;
  }

  .styles .item button {
    width: 100%;
  }
</style>


// WEBPACK FOOTER //
// src/components/generator/SelectStyle.vue